import { Injectable, Component, NgModule, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Observable, Subscription, BehaviorSubject } from 'rxjs';
import { DeepstreamClient } from '@deepstream/client';

import { environment } from '../../environments/environment';

declare var moment;

@Injectable({
  providedIn: 'root',
})
export class DeepstreamService {

  private ds;

  constructor(http: HttpClient) {}

  get dsInstance() {
    return this.ds;
  }

  public dsLogin(token) {
    const hostAndPort = window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    let loc = window.location.protocol === 'http:' ?
      'ws://'+hostAndPort+'/deepstream-v4' :
      'wss://'+hostAndPort+'/deepstream-v4';

    const deepstreamClient = new DeepstreamClient(loc)
    deepstreamClient.login({
      type: 'webhook',
      token: token
    }, (success, data) => {
      console.log(success, data);
    });
    this.ds = deepstreamClient;
  }
}
